import { render, staticRenderFns } from "./ClientAdministrationReports.vue?vue&type=template&id=58dcf56a&scoped=true&"
import script from "./ClientAdministrationReports.vue?vue&type=script&lang=ts&"
export * from "./ClientAdministrationReports.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAdministrationReports.vue?vue&type=style&index=0&id=58dcf56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dcf56a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VHover,VIcon,VRow,VSpacer})
